<template>
    <div class="cu-block-wrapper">
        <div class="cu-nav cu-nav-left" @click="goPrev" v-show="items_chunks.length > 1">
            <div></div>
        </div>
        <div class="cu-main-block" v-bind:class="{ 'no-chunks': hasNoChunks}">
            <div class="cu-logo-wrapper">
                <div class="cu-logo">
                    <img src="/img/cu_banner_logo.png" alt="Cengage Unlimited logo">
                </div>
                <div class="cu-promo-text">
                    <div>
                        Included with Cengage Unlimited, along with
                        <div class="cu-accent-color">thousands of other products!</div>
                    </div>
                </div>
            </div>
            <div class="cu-products-block">
                <div class="cu-product-block" v-for="item in items_to_display">
                    <div class="cu-product-cover">
                        <img :src="item.image_medium || '/img/no_image_medium.gif'" v-bind="ADAattr('hidden')" alt="product cover">
                    </div>
                    <div class="cu-product-bookinfo">
                        <p class="cu-product-title">{{item.title|truncate(60)}}</p>
                        <p class="cu-product-author">{{item.author}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="cu-nav cu-nav-right" @click="goNext" v-show="items_chunks.length > 1">
            <div></div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            bundled_products: {
                type: Array
            }
        },
        data() {
            return {
                items_per_chunk: 3,
                current_chunk: 0,
                hasNoChunks: false
            }
        },
        mounted() {
            this.calc_items_per_chunk();
            window.addEventListener('resize', this.calc_items_per_chunk);
        },
        computed: {
            items_chunks() {
                const fake_items = [
                    {
                        "title": "Bundle: Principles of Microeconomics, Loose-leaf Version, 8th + Aplia, 1 term Printed Access Card",
                        "author": "N. Gregory Mankiw",
                        "image_medium": "/images/medium/20/9781337379120.jpg",
                    }, {
                        "title": "Bundle: Principles of Macroeconomics, Loose-Leaf Version, 8th + Aplia, 1 term Printed Access Card",
                        "author": "N. Gregory Mankiw",
                        "image_medium": "/images/medium/63/9781337378963.jpg",
                    }, {
                        "title": "Bundle: Fundamentals of Financial Management, Loose-leaf Version, 15th + MindTap Finance, 2 terms (12 months) Printed Access Card",
                        "author": "Eugene F. Brigham, Joel F. Houston",
                        "image_medium": "/images/medium/76/9781337609876.jpg",
                    }, {
                        "title": "Bundle: Fundamentals of Financial Management, Loose-leaf Version, 15th + MindTap Finance, 1 term (6 months) Printed Access Card",
                        "author": "Eugene F. Brigham, Joel F. Houston",
                        "image_medium": "/images/medium/55/9781337817455.jpg",
                    }, {
                        "title": "Bundle: Accounting, Loose-leaf Version, 27th + CengageNOWv2, 2 terms Printed Access Card",
                        "author": "Warren/Reeve/Duchac",
                        "image_medium": "/images/medium/26/9781337587426.jpg",
                    },
                    {
                        "title": "I Got an A?! : Surprising Tips from Top Students about Why We Study All Wrong and How to Boost Your Grades to the Top",
                        "author": "Weisman, Stefanie",
                        "image_medium": "/images/medium/95/9781402280795.jpg",
                    }, {
                        "title": "Moleskine Ruled Notebook Large",
                        "author": "Moleskine",
                        "image_medium": "/images/medium/22/9788883701122.jpg",
                    }, {
                        "title": "The $5 a Meal College Cookbook Good Cheap Food for When You Need to Eat",
                        "author": "Rhonda Lauret Parkinson",
                        "image_medium": "/images/medium/88/9781440502088.jpg",
                    }, {
                        "title": "Bright Ideas Colored Pencils : 10 Colored Pencils",
                        "author": "Chronicle Books",
                        "image_medium": "/images/medium/74/9781452154374.jpg",
                    }, {
                        "title": "Between the World and Me",
                        "author": "Coates, Ta-Nehisi",
                        "image_medium": "/images/medium/47/9780812993547.jpg",
                    }
                ];
                // return _.chunk(fake_items, this.items_per_chunk);
                return _.chunk(this.bundled_products, this.items_per_chunk);
            },
            items_to_display() {
                if (!this.items_chunks.length) return [];
                this.hasNoChunks = this.items_chunks.length == 1;
                return this.items_chunks[this.current_chunk];
            }
        },
        methods: {
            calc_items_per_chunk() {
                if (window.outerWidth < 550) {
                    this.items_per_chunk = 1;
                } else if (window.outerWidth < 700) {
                    this.items_per_chunk = 2
                } else {
                    this.items_per_chunk = 3;
                }
            },
            goPrev() {
                if (this.current_chunk <= 0) {
                    this.current_chunk = this.items_chunks.length - 1;
                } else {
                    this.current_chunk--
                }
            },
            goNext() {
                if (this.current_chunk >= this.items_chunks.length - 1) {
                    this.current_chunk = 0
                } else {
                    this.current_chunk++
                }
            }
        },
        filters: {
            truncate: function(value, limit) {
                if (value.length > limit) {
                    value = value.substring(0, (limit - 3)) + '...';
                }
                return value
            }
        }
    }
</script>

<style scoped lang="less">
    .cu-block-wrapper {
        @media screen and (min-width: 500px) {
            border: 1px solid #ccc;
        }
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 25px;

        .no-chunks {
            padding: 0 40px;
        }
    }

    .cu-products-block {
        display: flex;
    }

    .cu-logo-wrapper {
        @media screen and (min-width: 700px) {
            display: flex;
        }
    }

    .cu-logo {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 24px;

        @media screen and (min-width: 500px) {
            height: 80px;
        }
    }

    .cu-logo img {
        width: 200px;
    }

    .cu-promo-text {
        font-size: 1.3em;
        text-align: center;
        display: flex;
        align-items: center;

        .cu-accent-color {
            color: #E13100;
        }
    }

    .cu-product-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        padding: 5px 16px 0px;
    }

    .cu-nav {
        display: flex;
        align-items: center;
        padding: 0 5px;

        @media screen and (min-width: 500px) {
            padding: 0 5px;
        }

        &:hover {
            cursor: pointer;
            & > div {
                background-color: #f2f2f2;
            }
        }

        & > div {
            @diam: 32px;
            @diam-mobile: 24px;
            font-size: 1.5em;
            border: 1px solid #ccc;
            border-radius: 999px;
            width: @diam-mobile;
            height: @diam-mobile;
            @media screen and (min-width: 500px) {
                width: @diam;
                height: @diam;
            }
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .cu-product-bookinfo {
        width: 100%;
        max-width: 200px;
        min-height: 80px;
        & > p {
            padding: 0;
            margin: 0;
        }

        .cu-product-title {
            font-weight: 600;
        }
    }


    .cu-product-cover {
        img {
            height: 80px;
        }
    }

    .cu-main-block {
        flex: 1;
    }

    .cu-nav-right > div {
        &:after {
            font-family: 'SSAir', 'sans-serif';
            font-size: 14px;
            content: "\F501";
            transform: rotate(270deg);
            padding-top: 5px;
        }
    }
    .cu-nav-left > div {
        &:after {
            font-family: 'SSAir', 'sans-serif';
            font-size: 14px;
            content: "\F501";
            transform: rotate(90deg);
            padding-top: 5px;
        }
    }
</style>
